export enum LinkStatus {
  UNCHECKED = 0,

  OK = 1,
  NOT_OK = 2,
  SPAMMY = 3,
  ERRORED = 4,
}

export interface CheckerEntry {
  href: string;
  status: LinkStatus;
  text: string;
}
